import { render, staticRenderFns } from "./SidebarForm.vue?vue&type=template&id=2a33627d&scoped=true&"
import script from "./SidebarForm.vue?vue&type=script&lang=js&"
export * from "./SidebarForm.vue?vue&type=script&lang=js&"
import style0 from "./SidebarForm.vue?vue&type=style&index=0&id=2a33627d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33627d",
  null
  
)

export default component.exports